// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #8F003C;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 0.5s linear infinite;
  align-self: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.form-title-header {
  font-family: "Rubik";
  text-decoration: none !important;
  color: rgb(143, 0, 60);
  align-self: center !important;
  text-align: center !important;
  margin-right: 8px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  padding: 0px !important;
  font-size: 42px;
}

.form-title-sso {
  font-family: "Rubik";
  text-decoration: none !important;
  color: rgb(0, 0, 0);
  align-self: center !important;
  text-align: center !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  font-size: 22px;
}

.container-fluid-loading-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100vh;
  padding: 15px;
}

.checking {
  font-family: "Rubik";
  align-self: center !important;
  text-align: center !important;
  font-size: 14px;
}

.title-checking-credentials {
  font-weight: 800;
  margin: 0px 0px !important;
  text-align: center;
  display: flex;
  padding: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/views/checkingcredentials/CheckingCredentials.scss","webpack://./src/components/views/checkingcredentials/CheckingCredentials.css"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;ACCJ;;ADGA;EACI;IACI,uBAAA;ECAN;EDGE;IACI,yBAAA;ECDN;AACF;ADIA;EACI,oBAAA;EACA,gCAAA;EACA,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;ACFJ;;ADKA;EACI,oBAAA;EACA,gCAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,eAAA;ACFJ;;ADKA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;ACFJ;;ADKA;EACI,oBAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;ACFJ;;ADKA;EACI,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;ACFJ","sourcesContent":[".loader {\n    border: 5px solid #f3f3f3;\n    border-top: 5px solid #8F003C;\n    border-radius: 50%;\n    width: 35px;\n    height: 35px;\n    animation: spin 0.5s linear infinite;\n    align-self: center;\n}\n\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.form-title-header {\n    font-family: 'Rubik';\n    text-decoration: none !important;\n    color: rgba(143, 0, 60, 1);\n    align-self: center !important;\n    text-align: center !important;\n    margin-right: 8px !important;\n    margin-bottom: 0px !important;\n    margin-top: 0px !important;\n    padding: 0px !important;\n    font-size: 42px;\n}\n\n.form-title-sso {\n    font-family: 'Rubik';\n    text-decoration: none !important;\n    color: rgb(0, 0, 0);\n    align-self: center !important;\n    text-align: center !important;\n    margin-bottom: 0px !important;\n    margin-top: 0px !important;\n    font-size: 22px;\n}\n\n.container-fluid-loading-page {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    height: 100vh;\n    padding: 15px;\n}\n\n.checking {\n    font-family: 'Rubik';\n    align-self: center !important;\n    text-align: center !important;\n    font-size: 14px;\n}\n\n.title-checking-credentials {\n    font-weight: 800;\n    margin: 0px 0px !important;\n    text-align: center;\n    display: flex;\n    padding: 0px !important;\n}",".loader {\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #8F003C;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  animation: spin 0.5s linear infinite;\n  align-self: center;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.form-title-header {\n  font-family: \"Rubik\";\n  text-decoration: none !important;\n  color: rgb(143, 0, 60);\n  align-self: center !important;\n  text-align: center !important;\n  margin-right: 8px !important;\n  margin-bottom: 0px !important;\n  margin-top: 0px !important;\n  padding: 0px !important;\n  font-size: 42px;\n}\n\n.form-title-sso {\n  font-family: \"Rubik\";\n  text-decoration: none !important;\n  color: rgb(0, 0, 0);\n  align-self: center !important;\n  text-align: center !important;\n  margin-bottom: 0px !important;\n  margin-top: 0px !important;\n  font-size: 22px;\n}\n\n.container-fluid-loading-page {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  height: 100vh;\n  padding: 15px;\n}\n\n.checking {\n  font-family: \"Rubik\";\n  align-self: center !important;\n  text-align: center !important;\n  font-size: 14px;\n}\n\n.title-checking-credentials {\n  font-weight: 800;\n  margin: 0px 0px !important;\n  text-align: center;\n  display: flex;\n  padding: 0px !important;\n}/*# sourceMappingURL=CheckingCredentials.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
